import React from 'react';
import Rimg from './Rimg.jsx';

export default function PictureBlock(props) {
  return (
    <section className={`picture-block picture-block-${props.alignment} picture-block-${props.width} ${props.className}`}>
      {props.image.src && <div className="picture-block-image mobile--hide">
        <Rimg {...props.image} alt={props.image.alt || props.heading} loading="lazy" />
        <div data-rimg-canvas />
      </div>}
      {props.mobile_image.src && <div className="picture-block-image desktop--hide">
        <Rimg {...props.mobile_image} alt={props.mobile_image.alt || props.heading} loading="lazy" />
      </div>}
      <div className="picture-block-wrapper">
        <div className="centering-wrapper">
          <div className="picture-block-content">
            <h2 className="picture-block-heading" dangerouslySetInnerHTML={{__html: props.heading}} />
            <div className="picture-block-body">
              <p dangerouslySetInnerHTML={{__html: props.content}} />
              <a href={props.link} className="related-collection-button action-button">{props.button}</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}